<template lang="pug">
#synchronized_resize_heatmap
  template(v-if="$store.state.heatmap.show_resize_heatmap")
    vue-resizable(style="position:absolute", :height="iframe_height", :active="handlers", @resize:move="eHandler", :key="resizeKey")
      .resizeable_block
      i.fas.fa-arrows-alt-v
      button.btn.btn-success.btn-sm.btn-fix-pageheight(@click="fixPageHeight")
        i.fas.fa-check.mr-2
        | 決定
</template>

<script>
import VueResizable from 'vue-resizable'
import Vue from 'vue'

export default {
  name: 'SynchronizedResizeHeatmap',
  props: {
    height: Number,
    token: String,
    instanceId: {
      type: String,
      required: true
    }
  },
  methods: {
    eHandler(data) {
      this.$store.commit("heatmap/setPageHeight", data.height)
    },
    async fixPageHeight(e) {
      await this.$store.dispatch("heatmap/fixPageHeight")
      location.href = `/users/heatmaps/${this.token}/edit_page_height?height=${this.$store.state.heatmap.preview_page_height}&device=${this.$store.state.heatmap.device}`
    }
  },
  data() {
    return {
      handlers: ["b"],
      resizeKey: 0,
      debounceTimer: null
    }
  },
  async mounted() {
    await Vue.nextTick()
  },
  watch: {
    '$store.state.heatmap.preview_page_height': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.debounceTimer) {
            clearTimeout(this.debounceTimer)
          }
          this.debounceTimer = setTimeout(() => {
            this.resizeKey++
          }, 50)
        }
      },
      immediate: true
    }
  },
  components: {
    VueResizable
  },
  computed: {
    iframe_height() {
      if (!this.$store.state.heatmap.page_height && !this.$store.state.heatmap.preview_page_height) {
        return this.height
      } else if (this.$store.state.heatmap.preview_page_height) {
        return this.$store.state.heatmap.preview_page_height + "px"
      } else {
        return this.$store.state.heatmap.page_height + "px"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#synchronized_resize_heatmap {
  .resizeable_block {
  }
}
</style>
